export default "__VITE_ASSET__D3QnU4P5__"